import { catalogConfigs } from "configs";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";

export default function Head() {
  const { title } = catalogConfigs;
  const { lang } = useParams();

  return (
    <Helmet>
      <title>{`${title[lang] ? title[lang] : title.default} | E-catalog`}</title>

      {/* Fonts */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
        rel="stylesheet"
      />
      {/* <link
        rel="stylesheet"
        type="text/css"
        href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard-dynamic-subset.css"
      /> */}
    </Helmet>
  );
}
